import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import tickerSubscriber from '../service/tickersubscriber';
import guid from '../service/guid';

function withTickerSubscribe(WrappedComponent) {
    const tickerSub = class WithTickerSubscribe extends Component {
        static propTypes = {
            symbol: PropTypes.string.isRequired,
            dispatch: PropTypes.func.isRequired,
        };

        componentDidMount() {
            this.channel = guid();

            tickerSubscriber.subscribe(this.channel, this.props.symbol);
        }

        componentWillUnmount() {
            if (this.channel) {
                tickerSubscriber.unsubscribe(this.channel);
            }
        }

        componentWillReceiveProps(nextProps) {
            if (nextProps.symbol !== this.props.symbol && this.channel) {
                tickerSubscriber.unsubscribe(this.channel);
                tickerSubscriber.subscribe(this.channel, nextProps.symbol);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return connect()(tickerSub);
}

export default withTickerSubscribe;



/** WEBPACK FOOTER **
 ** /src/shared/hoc/withTickerSubscribe.js
 **/